<ng-content select="label"></ng-content>

@if(uploadLoader()){
  <terra-loader></terra-loader>
}
@else{
  <div class="file-selector">
    <!-- When empty -->
    <div class="upload-button" *ngIf="!isDocumentSelected() && !showFileLoader()">
      <label>
        <span class="upload-text">{{ uploadButtonText }}</span>
        <input type="file" class="inputfile" #fileInput (change)="fileChange($event)" [accept]="supportedExtensions"/>
      </label>
    </div>
  
    <!-- While uploading / After finihsed uploading -->
    <div class="has-file" [ngClass]="{ finished: !showFileLoader() }" *ngIf="isDocumentSelected() || showFileLoader()">
      <label class="file-name-text link truncate lo_sensitive">{{ fileToUpload.name }}</label>
      <button type="button" mat-icon-button aria-label="Delete file" (click)="clearFile()">
        <mat-icon class="notranslate">close</mat-icon>
      </button>
    </div>
    <mat-progress-bar *ngIf="showFileLoader()" mode="determinate" [value]="uploadProgress" class="custom-progress-bar"></mat-progress-bar>
  </div>
}



<p class="type-hint" *ngIf="typeHint">{{ typeHint }}</p>
<div class="error-message validation-error" *ngIf="showValidationError()">
  <ul>
    @for (item of showValidationError(); track $index){
      <li>{{item}}</li>
    }
  </ul>
</div>
<p class="error-message" *ngIf="showFileUploadError()">
  <label class="has-error"> <i class="fa fa-error"></i> An error has occurred</label>
</p>
<p class="error-message" *ngIf="fileTypeNotSupported()">
  <label class="has-error"> <i class="fa fa-error"></i> Uploaded file type is not supported</label>
</p>
<p class="error-message" *ngIf="displayVirusDetectedError === true">
  <label class="has-error"> <i class="fa fa-error"></i> Virus detected</label>
</p>
